import {Routes} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {ErrorComponent} from './error/error.component';
import {canActivateAuthRole} from './utils/app-auth-guard';
import {LogoutComponent} from './logout/logout.component';
import {LoginComponent} from './login/login.component';
import {
  ApplicationUpdateComponent
} from './components/application-update/application-update.component';
import {
  ApplicationDocumentsComponent
} from "./components/application-documents/application-documents.component";
import {
  ApplicationDetailComponent
} from "./components/application-detail/application-detail.component";

export const routes: Routes = [
  {
    path: '', redirectTo: '/home', pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [canActivateAuthRole],
    data: {roles: ['principle-user']}
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [canActivateAuthRole],
    data: {roles: ['principle-user']}
  },
  {path: 'logout', component: LogoutComponent},
  {path: 'unauthorized', component: ErrorComponent},
  {
    path: 'application-update/:id',
    component: ApplicationUpdateComponent,
    canActivate: [canActivateAuthRole],
    data: {roles: ['principle-user']}
  },
  {
    path: 'application-detail/:id',
    component: ApplicationDetailComponent,
    canActivate: [canActivateAuthRole],
    data: {roles: ['principle-user']}
  },
  {
    path: 'application-documents/:id',
    component: ApplicationDocumentsComponent,
    canActivate: [canActivateAuthRole],
    data: {roles: ['principle-user']}
  }
];
